import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';

const FilterSidebar = ({ filters, onFilterChange, isOpen, onToggle }) => {
  const filterCategories = [
    {
      id: 'type',
      label: 'Content Type',
      options: [
        { value: 'guide', label: 'Strategic Guides', count: 24 },
        { value: 'report', label: 'Market Reports', count: 18 },
        { value: 'webinar', label: 'Webinars', count: 32 },
        { value: 'whitepaper', label: 'Whitepapers', count: 15 },
        { value: 'case-study', label: 'Case Studies', count: 28 },
        { value: 'checklist', label: 'Checklists', count: 12 }
      ]
    },
    {
      id: 'audience',
      label: 'Target Audience',
      options: [
        { value: 'c-suite', label: 'C-Suite Executives', count: 45 },
        { value: 'procurement', label: 'Procurement Teams', count: 32 },
        { value: 'operations', label: 'Operations Leaders', count: 38 },
        { value: 'hr', label: 'HR Directors', count: 25 },
        { value: 'finance', label: 'Finance Teams', count: 28 }
      ]
    },
    {
      id: 'topic',
      label: 'Topic Areas',
      options: [
        { value: 'gcc-setup', label: 'GCC Setup & Strategy', count: 42 },
        { value: 'talent', label: 'Talent Acquisition', count: 35 },
        { value: 'compliance', label: 'Regulatory Compliance', count: 28 },
        { value: 'operations', label: 'Operational Excellence', count: 31 },
        { value: 'technology', label: 'Technology Integration', count: 24 },
        { value: 'cost-optimization', label: 'Cost Optimization', count: 19 }
      ]
    },
    {
      id: 'industry',
      label: 'Industry Focus',
      options: [
        { value: 'technology', label: 'Technology', count: 38 },
        { value: 'financial-services', label: 'Financial Services', count: 32 },
        { value: 'healthcare', label: 'Healthcare', count: 25 },
        { value: 'manufacturing', label: 'Manufacturing', count: 28 },
        { value: 'retail', label: 'Retail & E-commerce', count: 22 }
      ]
    },
    {
      id: 'difficulty',
      label: 'Complexity Level',
      options: [
        { value: 'beginner', label: 'Beginner', count: 35 },
        { value: 'intermediate', label: 'Intermediate', count: 48 },
        { value: 'advanced', label: 'Advanced', count: 26 },
        { value: 'expert', label: 'Expert', count: 18 }
      ]
    }
  ];

  const handleFilterChange = (categoryId, value, checked) => {
    onFilterChange(categoryId, value, checked);
  };

  const clearAllFilters = () => {
    filterCategories.forEach(category => {
      category.options.forEach(option => {
        onFilterChange(category.id, option.value, false);
      });
    });
  };

  const getActiveFilterCount = () => {
    return Object.values(filters).flat().length;
  };

  return (
    <>
      {/* Mobile Filter Toggle */}
      <div className="lg:hidden mb-6">
        <button
          onClick={onToggle}
          className="flex items-center justify-between w-full p-4 bg-card rounded-lg border border-border"
        >
          <div className="flex items-center">
            <Icon name="Filter" size={20} className="mr-2" />
            <span className="font-medium">Filters</span>
            {getActiveFilterCount() > 0 && (
              <span className="ml-2 px-2 py-1 bg-primary text-primary-foreground rounded-full text-xs">
                {getActiveFilterCount()}
              </span>
            )}
          </div>
          <Icon name={isOpen ? "ChevronUp" : "ChevronDown"} size={20} />
        </button>
      </div>

      {/* Filter Sidebar */}
      <div className={`lg:block ${isOpen ? 'block' : 'hidden'} lg:sticky lg:top-24`}>
        <div className="bg-card rounded-xl border border-border p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="font-headline font-semibold text-lg text-text-primary">
              Filter Resources
            </h3>
            {getActiveFilterCount() > 0 && (
              <button
                onClick={clearAllFilters}
                className="text-sm text-primary hover:text-primary transition-colors duration-300"
              >
                Clear All
              </button>
            )}
          </div>

          <div className="space-y-6">
            {filterCategories.map((category) => (
              <div key={category.id}>
                <h4 className="font-medium text-text-primary mb-3">
                  {category.label}
                </h4>
                <div className="space-y-2">
                  {category.options.map((option) => (
                    <div key={option.value} className="flex items-center justify-between">
                      <Checkbox
                        label={option.label}
                        checked={filters[category.id]?.includes(option.value) || false}
                        onChange={(e) => handleFilterChange(category.id, option.value, e.target.checked)}
                        className="flex-1"
                      />
                      <span className="text-sm text-text-secondary ml-2">
                        {option.count}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Quick Actions */}
          <div className="mt-8 pt-6 border-t border-border">
            <h4 className="font-medium text-text-primary mb-3">Quick Actions</h4>
            <div className="space-y-2">
              <button className="w-full text-left p-2 rounded-lg hover:bg-muted transition-colors duration-300 text-sm">
                <Icon name="TrendingUp" size={16} className="inline mr-2" />
                Most Popular This Week
              </button>
              <button className="w-full text-left p-2 rounded-lg hover:bg-muted transition-colors duration-300 text-sm">
                <Icon name="Clock" size={16} className="inline mr-2" />
                Recently Added
              </button>
              <button className="w-full text-left p-2 rounded-lg hover:bg-muted transition-colors duration-300 text-sm">
                <Icon name="Star" size={16} className="inline mr-2" />
                Highest Rated
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterSidebar;